import {
  CampaignConfigDto,
  DiscountDto,
  RewardConfigDtoTypeEnum,
} from '@coretava/api/ecommerce-service';
import React from 'react';
import { observer } from 'mobx-react';
import BogoCampaign from './BogoCampaign';
import NonBogoCampaign from './NonBogoCampaign';

type Props = {
  campaign: CampaignConfigDto,
  discount?: DiscountDto,
  textAlign?: 'center' | 'left'
}

const BasicCampaign: React.FC<Props> = ({ campaign, discount, textAlign }) => (
  campaign.rewardConfig?.type === RewardConfigDtoTypeEnum.Bogo
    ? (
      <BogoCampaign
        campaign={campaign}
        textAlign={textAlign}
      />
    )
    : (
      <NonBogoCampaign
        campaign={campaign}
        discount={discount}
      />
    ));

export default observer(BasicCampaign);
